/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'UserCOC' store object.
 * @namespace UserCOCSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAUserCOC';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserCOCSelectors
   */
  static fetchSdCocApplicationForm = state =>
    state[selectors.moduleIdentifier].fetchSdCocApplicationForm.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserCOCSelectors
   */
  static isFetchingFetchSdCocApplicationForm = state =>
    state[selectors.moduleIdentifier].isFetchingFetchSdCocApplicationForm.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserCOCSelectors
   */
  static fetchSdCocApplicationFormError = state =>
    state[selectors.moduleIdentifier].fetchSdCocApplicationFormError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserCOCSelectors
   */
  static fetchSdExternaluserCocStatus = state =>
    state[selectors.moduleIdentifier].fetchSdExternaluserCocStatus.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserCOCSelectors
   */
  static isFetchingFetchSdExternaluserCocStatus = state =>
    state[selectors.moduleIdentifier].isFetchingFetchSdExternaluserCocStatus.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserCOCSelectors
   */
  static fetchSdExternaluserCocStatusError = state =>
    state[selectors.moduleIdentifier].fetchSdExternaluserCocStatusError.payload;

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserCOCSelectors
   */
  static deleteApplicationFormByApplicationFormId = state =>
    state[selectors.moduleIdentifier].deleteApplicationFormByApplicationFormId.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserCOCSelectors
   */
  static isFetchingDeleteApplicationFormByApplicationFormId = state =>
    state[selectors.moduleIdentifier].isFetchingDeleteApplicationFormByApplicationFormId.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof UserCOCSelectors
   */
  static deleteApplicationFormByApplicationFormIdError = state =>
    state[selectors.moduleIdentifier].deleteApplicationFormByApplicationFormIdError.payload;
}
